import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import SEO from '../SEO/SEO';

const ThankYou = () => {
    return (
        <div className="min-h-[60vh] flex items-center justify-center p-4">
            <SEO 
                title="Thank You" 
                robots="noindex, nofollow" 
            />
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                className="max-w-3xl w-full bg-white rounded-2xl shadow-large p-12 text-center"
            >
                <h1 className="text-4xl font-bold text-primary-600 mb-6 font-sans">
                    Thank You
                </h1>
                <p className="text-gray-600 text-lg leading-relaxed font-sans">
                    Thank you for reaching out to Aham Housing Finance. We shall address your requirements shortly. For more details please call at 078239 11555.
                </p>
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.8 }}
                    className="mt-10"
                >
                    <Link
                        to="/"
                        className="inline-block px-8 py-3 bg-primary-600 text-white rounded-xl font-semibold hover:bg-primary-700 transition-all shadow-md hover:shadow-lg"
                    >
                        Back to Home
                    </Link>
                </motion.div>
            </motion.div>
        </div>
    );
};

export default ThankYou;
